import { styled } from "../../../../../../Utils/stitches.config";
import { primaryColor } from "../../../../../../Utils/themeConfig";
export const StyledQuizSelect = styled("div",{
    "&:hover":{
        color:primaryColor
    }
})